<template lang="pug">
  .search-box
    input.search-box__input(:placeholder='placeholder' v-model="currentValue" @input="$emit('input', $event.target.value)")
    button.clear-button.search-box__clear(v-show="isShowClearButton" @click="clearCurrentValue")
      v-icon.search-box__clear-icon(name="x")
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "Поиск",
    },
  },
  data() {
    return {
      currentValue: "",
    }
  },
  computed: {
    isShowClearButton() {
      return this.currentValue.length;
    }
  },
  methods: {
    clearCurrentValue() {
      this.currentValue = "";
      this.$emit('input', this.currentValue);
    }
  }
};
</script>
